import { Address } from "../Address";
import { IAddress } from "../interfaces/IAddress";

export interface IServerAddress {
    id: number;
    lineOne: string;
    lineTwo?: string;
    city: string;
    state: string;
    zipCode: string;
    name?: string;
    wheelchairAccessible: boolean;
    publicTransportation: boolean;
}

export class ServerAddress implements IServerAddress {
    id: number;
    lineOne: string;
    lineTwo?: string;
    city: string;
    state: string;
    zipCode: string;
    name?: string;
    wheelchairAccessible: boolean;
    publicTransportation: boolean;

    constructor(clientOrServerObject: Address | IServerAddress) {
        this.id = clientOrServerObject.id;
        this.lineOne = clientOrServerObject.lineOne;
        this.lineTwo = clientOrServerObject.lineTwo;
        this.city = clientOrServerObject.city;
        this.state = clientOrServerObject.state;
        this.zipCode = clientOrServerObject.zipCode;
        this.name = clientOrServerObject.name;
        this.wheelchairAccessible = clientOrServerObject.wheelchairAccessible;
        this.publicTransportation = clientOrServerObject.publicTransportation;
    }

    deserialize(): IAddress {
        return {
            id: this.id,
            lineOne: this.lineOne,
            lineTwo: this.lineTwo,
            city: this.city,
            state: this.state,
            zipCode: this.zipCode,
            name: this.name,
            options: {
                wheelchairAccessible: this.wheelchairAccessible,
                publicTransportation: this.publicTransportation
            }
        }
    }

    deprecatedDeserialize(): Address {
        return new Address(this);
    }
}